import { Component, inject, OnInit } from '@angular/core';
import { OutcomesService } from '../outcomes.service';
import { decodeBase64ToText, encodeToBase64 } from '../../../utility';
import { FilterGroup } from '../outcomes-interface';
import { AuthService } from '../../../auth/auth.service';
import { ToastService } from '../../../shared/services/toast.service';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { HelperService } from '../../../shared/services/helper.service';

@Component({
  selector: 'app-sync',
  templateUrl: './sync.component.html',
  styleUrl: './sync.component.css',
})
export class SyncComponent implements OnInit {
  helper = inject(HelperService);
  selectedTemplate = '';
  selectedGroup = '';
  selectedUser = '';
  user = '';
  user_id: number;
  userInfo: any;
  groupFilter: FilterGroup[] = [];
  parentgroupFilter: FilterGroup[] = [];
  users: any[] = [];
  templateFilter: any[] = [
    { label: 'Individual', value: 'individual' },
    { label: 'Team', value: 'team' },
    { label: 'Affiliate', value: 'affiliate' },
    { label: 'Teamparent', value: 'teamparent' },
  ];

  private outcomesService = inject(OutcomesService);
  private authService = inject(AuthService);
  private toastService = inject(ToastService);
  public ref = inject(DynamicDialogRef);

  ngOnInit(): void {
    // this.getGroupsList();
    // this.getUsersList();
    this.userInfo = JSON.parse(
      decodeBase64ToText(this.authService.getCookie())
    );
    this.user = this.userInfo.data.name;
    this.user_id = this.userInfo.data.user_id;
  }

  onSyncGroupSearch(event: any) {
    this.getGroupsList(event.filter);
  }

  getGroupsList(search?: any) {
    const payload = { type: 'all', link: 'all', search };
    this.outcomesService.getGroups(payload).subscribe(
      (data: any) => {
        try {
          const parsedData = data;
          const group = parsedData.data || [];

          this.parentgroupFilter = group.filter(
            (group: any) => group.link === 'parent'
          );
          this.groupFilter = group.filter(
            (group: any) => group.link !== 'parent'
          );
          // if (group) {
          //   const parentGrp = [
          //     ...group.cluster.parent,
          //     ...group.function.parent,
          //   ];
          //   const allgrup = [
          //     ...group.cluster.child,
          //     ...group.function.child,
          //     ...group.chapter.standalone,
          //     ...group.cluster.standalone,
          //     ...group.function.standalone,
          //   ];

          // this.groupFilter = allgrup.map((item: any) => ({
          //   label: item.name,
          //   value: item.group_id,
          // }));
          // this.parentgroupFilter = parentGrp.map((item: any) => ({
          //   label: item.name,
          //   value: item.group_id,
          // }));
          //let newItem = { "label": "All Groups", "value": -1 };
          // Use unshift() to add it at the beginning of the array
          ///this.groupFilter.unshift(newItem);
          //this.parentgroupFilter.unshift(newItem);
          // }
        } catch (error) {
          console.error('Error parsing decoded data:', error);
        }
      },
      (error) => {
        console.error('Error fetching users', error);
      }
    );
  }

  getUsersList(data?:any) {
    let payload = { start: '0', search: data };
    this.outcomesService.getUsers(payload).subscribe(
      (data: any) => {
        try {
          const parsedData = data;

          const user = parsedData.data || [];
          if (user.length > 0) {
            this.users = user;
          }
        } catch (error) {
          console.error('Error parsing decoded data:', error);
        }
      },
      (error) => {
        console.error('Error fetching users', error);
      }
    );
  }

  changeTemplate(event: any) {
    if (event.value == 'team' || event.value == 'teamparent') {
      this.getGroupsList();
    }
    else if (event.value == 'individual') {
      this.getUsersList();
    }
  }

  onSyncUserSearch(event: any) {
    let userName = event.filter;
    this.getUsersList(userName);
  }

  syncTemplateToOutcomes(form: any) {
    if (form.valid) {

      const formData = { type: form.value.selectedTemplate, ...form.value };
      this.outcomesService.syncTempToOutcomes(formData).subscribe(
        (data: any) => {
          try {
            const parsedData = data;
            if (parsedData.error) {
              this.toastService.error(parsedData.message);
            } else {
              this.toastService.success(parsedData.message);
              this.ref.close();
            }
          } catch (error) {
            console.error('Error parsing decoded data:', error);
          }
        },
        (error) => {
          console.error('Error fetching users', error);
        }
      );
    }
  }
}
